import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { delay, Observable, of } from 'rxjs';
import { Permission } from 'src/app/data/model/permission';
import { User, UserTableVisualization } from 'src/app/data/model/user';
import { UserPortalGroup } from 'src/app/data/model/user-portal-group';
import { AppActions, AppSelectors } from 'src/app/store/app-store';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayoutComponent implements OnInit {
  @ViewChild('content', { static: true })
  private content: TemplateRef<unknown>;
  group$:Observable<UserPortalGroup[]>=  this.store.select(AppSelectors.selectGroup);
  showNav$: Observable<boolean>;

  public user$: Observable<User> = this.store.select(AppSelectors.selectUser);
  public viewPermissions$: Observable<Permission[]> = this.store.select(
    AppSelectors.selectViewPermssions
  );
  public viewModules$: Observable<UserTableVisualization[]> = this.store.select(
    AppSelectors.selectViewModules
  );

  constructor(
    private store: Store,
    private breakpointObserver: BreakpointObserver
  ) {}

  /**
   * Restituisce il template attivo in funzione dello stato dell'app
   */
  get template$(): Observable<TemplateRef<unknown>> {
    return of(this.content);
  }

  get loading$(): Observable<boolean> {
    return this.store.select(AppSelectors.selectLoading).pipe(delay(0));
  }


  ngOnInit(): void {
    this.viewPermissions$ = this.store.select(AppSelectors.selectViewPermssions);
    this.viewModules$=this.store.select(
      AppSelectors.selectModules
    );
    this.group$=  this.store.select(AppSelectors.selectGroup);
    this.showNav$ = this.store.select(AppSelectors.selectNavbar);
 
    this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.Medium])
      .subscribe((result) => {
        if (!result.matches) this.store.dispatch(AppActions.hideNav());
      });
  }

  public closeSidebar() {
    this.store.dispatch(AppActions.hideNav());
  }
}
